import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { updateCompanyBasicInformation } from "../../../../actions/companyActions";
import { getVoiceOfSeniors } from "../../../../reducers/companySelector";
import { useTranslation } from "react-i18next";
import { setCompletionBool } from "../index";
import Voice from "./voiceCard";
import DeleteVoiceModal from "./deleteVoiceModal";
import { usePreviousState } from "../../../../utils/customHooks";
import VoiceFormItems from "./voiceFormItems";
import { Card, Empty, Form } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import GalkButton from "../../../common/component/button";
import "./style.css";

const VoiceOfSeniors = ({
	voiceOfSeniors,
	isActionProgress,
	updateCompanyBasicInformation,
}) => {
	const [voiceToDelete, setVoiceToDelete] = useState(null);
	const [showCreatePanel, setShowCreatePanel] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [form] = Form.useForm();
	const { t } = useTranslation();
	const prevActionInProgressValue = usePreviousState(isActionProgress);

	useEffect(() => {
		if (!voiceOfSeniors || voiceOfSeniors.length === 0) {
			setCompletionBool("voiceOfSeniors", 0);
		} else {
			setCompletionBool("voiceOfSeniors");
		}
	}, [voiceOfSeniors]);

	useEffect(() => {
		if (!isActionProgress && prevActionInProgressValue) {
			setShowCreatePanel(false);
			form.resetFields();
		}
	}, [isActionProgress]);

	const deleteVoice = (job) => {
		setVoiceToDelete({ ...job });
		setShowDeleteModal(true);
	};
	const closeDeleteModal = () => {
		setVoiceToDelete(null);
		setShowDeleteModal(false);
	};

	const addVoice = (formValues) => {
		const oldList = voiceOfSeniors || [];
		const newList = {
			voiceOfSeniors: [{ ...formValues }, ...oldList],
		};

		updateCompanyBasicInformation(newList);
	};

	return (
		<Card
			type="inner"
			title={
				<div className="voiceOfSeniors_container_card_title_container">
					<div className="voiceOfSeniors_container_card_title_primary">
						{t("accountSetting_voiceOfSenior_sectionTitle_primary")}
					</div>
					<div className="voiceOfSeniors_container_card_title_secondary">
						<span>
							※ {t("accountSetting_voiceOfSenior_sectionTitle_secondary")}
						</span>
					</div>
				</div>
			}
			extra={
				<div style={{ display: "flex", alignItems: "baseline" }}>
					<GalkButton
						type="primary"
						height={36}
						additionalStyle={{ padding: "13px 16px" }}
						onClick={() => setShowCreatePanel(true)}
						// disabled={isLoading}
					>
						<PlusOutlined />
						{t("accountSetting_voiceOfSenior_action_add")}
					</GalkButton>
				</div>
			}
		>
			<div className="project_container">
				{showCreatePanel && (
					<div className="voice_card_container">
						<Form
							layout="vertical"
							form={form}
							initialValues={{}}
							onFinish={addVoice}
						>
							<VoiceFormItems
								isActionProgress={isActionProgress}
								action={"create"}
								cancelActionHandler={() => {
									setShowCreatePanel(false);
									form.resetFields();
								}}
							/>
						</Form>
					</div>
				)}
				{(!voiceOfSeniors || (voiceOfSeniors && voiceOfSeniors.length < 1)) && (
					<div
						style={{
							display: "flex",
							flexDirection: "divumn",
							justifyContent: "center",
							width: "100%",
							height: "30vh",
						}}
					>
						<Empty />
					</div>
				)}
				{voiceOfSeniors &&
					voiceOfSeniors.map((voice) => (
						<Voice
							key={voice.index}
							voice={voice}
							deleteHandler={deleteVoice}
							voiceList={voiceOfSeniors}
						/>
					))}
			</div>
			{showDeleteModal && (
				<DeleteVoiceModal
					voiceDetails={voiceToDelete}
					modalCloseHandler={closeDeleteModal}
					voiceList={voiceOfSeniors}
				/>
			)}
		</Card>
	);
};
const mapStateToProps = (state) => ({
	voiceOfSeniors: getVoiceOfSeniors(state),
	isActionProgress: state.company.actionInProgress,
});

export default connect(mapStateToProps, { updateCompanyBasicInformation })(
	VoiceOfSeniors
);
